import { useEffect, FunctionComponent, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { history } from '../../history';
import { AuthStore } from '../../context';
import { usePrevious } from '../../hooks';

/**
 * Load the last loaded page for a given merchant based on the merchant in the
 * auth token and last page saved in localStorage
 */
export const PathMemory: FunctionComponent = () => {
  const {
    state: { auth },
  } = useContext(AuthStore);
  const { pathname, search } = useLocation();

  const merchantId = auth?.merchant?.id;
  const key = merchantId && `selfreg.pathname.${merchantId}`;
  const prevKey = usePrevious(key);

  useEffect(() => {
    if (key && key !== prevKey) {
      const savedPathname = localStorage.getItem(key) || '/welcome';
      history.push(savedPathname + search);
    }
  }, [key, prevKey, search]);

  useEffect(() => {
    if (key) {
      localStorage.setItem(key, pathname);
    }
  }, [key, pathname]);

  return null;
};
